// extracted by mini-css-extract-plugin
module.exports = {"partners__content":"Partners_partners__content__dOJDo","partners__header":"Partners_partners__header__1UVfo","partners__description":"Partners_partners__description__2Jwjl"};